<template>
  <div>
    <div v-if="isValid">
      <span v-if="discount.type==1" :class="classe">{{discount.value}}%</span>
      <span v-else>
        <span v-if="discount.netType=='UNIT'" :class="classe">{{$t('common.priceByUnity', { value: discount.value})}}</span>
        <span v-else :class="classe">{{discount.amount}}$</span>
      </span>
    </div>
    <span v-else :class="classe">{{$t('common.notAvailableDash')}}</span>
  </div>
</template>
<script>
export default {
	name: 'Discount',
  props: {
    discount : {
      type : Object,
      default : null
    },
    classe : {
      type: String,
      default : 'fs-12 secondary-text'
    }
  },
	data() {
		return {}
	},
  computed: {
    isValid () {
      return this.discount != null && _.get(this.discount, 'value') != null;
    }
  },
	methods: {

  },
  mounted() {

  }
}
</script>
<style>
</style>
